import { CommonModule } from '@angular/common';
import { Component, OnInit, signal, inject } from '@angular/core';
import { NavigationEnd, RouterLink } from '@angular/router';
import { ClaimRow } from '../../models/api/view/claim-view/claim-row';
import { Action } from '../../models/core/action';
import { FormatClaimPipe } from '../../pipes/format-claim.pipe';
import { BaseComponent } from '../base/base.component';
import { LinkLabelComponent } from '../core/labels/link-label.component';

@Component({
  selector: 'app-breadcrumb',
  imports: [CommonModule, RouterLink, LinkLabelComponent],
  template: `
    @if (show) {
      <nav class="tw-p-4" aria-label="Breadcrumb">
        @for (link of links; track link.label; let last = $last) {
          @if (link.disabled) {
            <span
              class="tw-font-bold tw-text-[var(--sed-black-60-color)]"
              aria-current="true"
            >
              {{ link.label }}</span
            >
          } @else {
            <app-link-label [routerLink]="link.routerLink">{{
              link.label
            }}</app-link-label>
          }
          @if (!last) {
            <span class="tw-pl-2 tw-pr-1" aria-hidden="true">/</span>
          }
        }
      </nav>
    }
  `,
  styles: ``,
})
export class BreadcrumbComponent extends BaseComponent implements OnInit {
  private formatClaim = inject(FormatClaimPipe);

  claim: ClaimRow;

  claimUrl: any[];

  show = false;

  links: Action[] = [];

  title = signal<string>('');

  ngOnInit() {
    this.buildLinks();
    this.dispose.subs = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        // TODO: find better way to be notified of page title change
        this.dispose.timeouts = setTimeout(() => {
          this.buildLinks();
        }, 0);
      }
    });
  }

  buildLinks() {
    const parts = window.location.pathname.substring(1).split('/');
    if (parts[0] === 'view') {
      this.buildViewLinks(parts);
    } else {
      this.show = false;
    }
  }

  buildViewLinks(parts: string[]) {
    this.claim = this.view.currentClaim();
    this.claimUrl = this.view.buildUrl([]);
    this.show = true;
    this.links = [];

    if (parts.length === 1) {
      this.show = false;
    } else if (parts.length === 4) {
      this.links.push(
        {
          label: 'View',
          routerLink: '/view',
        },
        {
          disabled: true,
          label: this.formatClaim.transform(
            this.claim.fileNumber,
            this.claim.fileNumFormat,
          ),
          routerLink: this.claimUrl,
        },
      );
    } else if (parts.length === 5) {
      this.links.push(
        {
          label: 'View',
          routerLink: '/view',
        },
        {
          label: this.formatClaim.transform(
            this.claim.fileNumber,
            this.claim.fileNumFormat,
          ),
          routerLink: this.claimUrl,
        },
        {
          label: this.pageTitle,
          routerLink: this.claimUrl,
          disabled: true,
        },
      );
    } else if (parts.length === 6) {
      this.links.push(
        {
          label: 'View',
          routerLink: '/view',
        },
        {
          label: this.formatClaim.transform(
            this.claim.fileNumber,
            this.claim.fileNumFormat,
          ),
          routerLink: this.claimUrl,
        },
        {
          label: this.pageTitle,
          routerLink: this.claimUrl,
          disabled: true,
        },
      );
    }
  }
}
